const newResultModel = require('./resultModel');
const {
    modelCollection
} = require('gui');

module.exports = function resultsModel(dtos = []) {
    const models = dtos.map(dto => newResultModel(dto.Found));
    return modelCollection(models);
};
